"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.stat.scheduled': 'Scheduled',
    'socialMediaPlan.stat.drafts': 'Drafts & review',
    'socialMediaPlan.stat.published': 'Published',
    'socialMediaPlan.stat.total': 'Total posts',
};
